import Vue from 'vue';
import {
  Alert,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Loading,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  Option,
  Pagination,
  Popconfirm,
  Popover,
  Select,
  Table,
  TableColumn,
  Tag,
  Tooltip,
} from 'element-ui';
import lang from 'element-ui/lib/locale/lang/ru-RU';
import locale from 'element-ui/lib/locale';
import 'element-ui/lib/theme-chalk/base.css';

locale.use(lang);

[
  Alert,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Menu,
  MenuItem,
  Option,
  Pagination,
  Popconfirm,
  Popover,
  Select,
  Table,
  TableColumn,
  Tag,
  Tooltip,
].forEach((component) => Vue.use(component));

Vue.use(Loading.directive);
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
